export default __webpack_public_path__ + "static/plexus-mobile-1-4274687495b5774e41a23954d234ecaf.avif";